function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlacklistGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon open-ban",
    d: "M20 0a20 20 0 1 0 20 20A20.059 20.059 0 0 0 20 0zm0 5a14.963 14.963 0 0 1 8.75 2.8L7.8 28.75A15.017 15.017 0 0 1 20 5zm12.2 6.25A15.017 15.017 0 0 1 11.25 32.2z",
    style: {
      fill: "#7a8b99"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlacklistGrey);
export default __webpack_public_path__ + "static/media/blacklistGrey.0684f751b81e3e821e55b92889d70810.svg";
export { ForwardRef as ReactComponent };